module.exports = __webpack_public_path__ + "img/teste.6792b659.svg";